<div
    *ngIf="task"
    nz-row
    class="task-card"
>
    <div
        nz-col
        [nzMd]="user ? 12:  24"
        class="task-card-lead"
        *ngIf="user"
    >
        <div class="lead-title">
            <a (click)="onLeadClick()">{{ user?.firstName + ' ' +
                user?.lastName | titlecase }}
            </a>
        </div>
        <div class="lead-info">
            <div>
                <a [href]="'tel:' + user?.phone"><i
                        nz-icon
                        nzType="phone"
                        nzTheme="outline"
                    ></i>
                    {{ user?.phone }}</a>
            </div>
            <div>
                <a [href]="'mailto:' + user?.email"><i
                        nz-icon
                        nzType="mail"
                        nzTheme="outline"
                    ></i>
                    {{ user?.email }}</a>
            </div>
            <div>
                <i
                    nz-icon
                    nzType="home"
                    nzTheme="outline"
                ></i>
                {{ user?.address?.city }} {{ user?.address?.province }}
            </div>
        </div>
    </div>

    <div
        nz-col
        [nzMd]="user ? 12:  24"
        class="task-card-type"
    >
        <!-- type -->
        <div class="type-header">
            <div
                class="task-title"
                (click)="onTypeClick()"
            >
                {{ task.type }}
            </div>

            <div class="task-number">
                #{{number}}
            </div>
        </div>
        <!-- description -->
        <p
            class="type-description"
            nz-typography
            [nzEditable]="isEditable"
            [(nzContent)]="description"
            (nzContentChange)="onDescriptionChange($event)"
        ></p>
        <!-- notes -->
        <textarea
            [nzAutosize]="{ minRows: 2, maxRows: 4 }"
            nz-input
            [(ngModel)]="notes"
            (blur)="onNotesChange()"
            [readonly]="!isEditable"
            placeholder="notes"
        ></textarea>
    </div>

    <!-- ----------------------------------------------------------------------- -->
    <!--                                 Footer                                  -->
    <!-- ----------------------------------------------------------------------- -->

    <div
        nz-col
        nzSpan="24"
        class="task-card-footer"
    >
        <div class="task-status">
            Status:
            <nz-select
                class="status-select"
                nzPlaceHolder="status"
                [disabled]="!isEditable"
                [(ngModel)]="status"
                (ngModelChange)="onStatusChange($event)"
            >
                <nz-option
                    *ngFor="let status of taskStatuses | keyvalue"
                    [nzLabel]="status.value.label"
                    [nzValue]="status.key"
                >
                </nz-option>
            </nz-select>
        </div>
        <div class="task-divider"></div>
        <div class="task-tags">
            <nz-select
                (ngModelChange)="onTagsChange($event)"
                [(ngModel)]="tags"
                class="tasks-select"
                nzMode="tags"
                nzPlaceHolder="tags"
                [disabled]="!isEditable"
            >
                <nz-option
                    *ngFor="let option of taskTags"
                    [nzLabel]="option.label"
                    [nzValue]="option.value"
                >
                </nz-option>
            </nz-select>
        </div>
        <div class="task-divider"></div>
        <div class="task-time">{{ task?.createdAt | date: 'h:mm a' }}</div>
    </div>
</div>